import React from 'react';

import styled from '@emotion/styled';

import Img from '../Img/Img';

interface ICard {
  imgSrc: string;
  name: string;
  profession: string;
  note: string;
}

const AsideModalProfileCard: React.FC<ICard> = ({
  imgSrc,
  name,
  profession,
  note,
}) => {
  return (
    <Container>
      <ImageContainer>
        <Img src={imgSrc} alt="shift location image" />
      </ImageContainer>
      <Title>{name}</Title>
      <Description>{profession}</Description>
      <Note>{note}</Note>
    </Container>
  );
};

export default AsideModalProfileCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  color: black;
  box-shadow: 0px 20px 26px 0px rgba(186, 182, 182, 0.16);
  border-radius: 0.25rem;
`;

const ImageContainer = styled.div`
  width: 8.125rem;
  margin-left: 5rem;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  font-size: 1rem;
  text-align: center;
  font-weight: 400;
  line-height: normal;
`;

const Description = styled.div`
  font-size: 1rem;
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
  font-weight: 300;
  color: #2857d1;
`;

const Note = styled.div`
  font-size: 1rem;
  text-align: left;
`;
